import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import TextareaField from "@/components/shared/inputs/TextareaField";

const ModificationSection = ({
  title,
  subtitle,
  current,
  recommended,
  icon,
  showComment = false,
}) => {
  return (
    <div className="p-[1.75rem] border border-border rounded-[0.75rem] space-y-6 mt-[1.5rem]">
      <div className="flex items-start gap-2">
        <Checkbox />

        <div className="space-y-0.5">
          <Label className="capitalize text-black !text-sm !font-medium">
            {title}
          </Label>

          <p className="text-blue-300 text-sm">{subtitle}</p>

          <div className="flex items-center gap-2">
            {/* Current */}
            <div className="bg-sidebar rounded-full w-fit capitalize p-[0.75rem] text-sm text-secondary mt-3 font-medium">
              current: {current}
            </div>

            {/* Recommended (optional) */}
            {recommended && (
              <div className="flex items-center gap-2 border rounded-full bg-[#FCFDFD] border-popover-foreground capitalize p-[0.75rem] text-sm bg-gradient-to-br from-[#076698] via-[#054567] to-[#022232] bg-clip-text text-transparent mt-3 font-medium">
                {icon}
                recommended: {recommended}
              </div>
            )}
          </div>
        </div>
      </div>

      {showComment && (
        <TextareaField
          label="comment"
          placeholder="Explain What Changes You’re Requesting And Why..."
        />
      )}
    </div>
  );
};

export default ModificationSection;
